import { render } from "./Sidebar.vue?vue&type=template&id=f4519f72"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=f4519f72&lang=scss"
script.render = render

export default script